import { Colors } from 'basic-ui-lib/constants';
import { Box } from '../Box';
import { Badge } from 'antd';
import { Text } from '../Text';
import styled from 'styled-components';

export interface StatusTagProps {
  backgroundColor?: string;
  label: string;
  color?: string;
}

const StatusTag = ({ backgroundColor, label, color }: StatusTagProps) => {
  return (
    <Container       
      backgroundColor={backgroundColor}
      display='flex'
      padding='0px 8px'
      borderRadius='100px'
      alignItems='center'
      gap={4}
      width='fit-content'
    >
      <Badge dot color={color || Colors.neutral.bg[1]} />
      <Text body_1 color='neutral.text.1' style={{ color: color }}>
        {label}
      </Text>
    </Container>
  );
};

export default StatusTag;

const Container = styled(Box)`
  @media (max-width: 768px) {
    padding: 2px 8px!important;
    height: fit-content;
  }
`;
